export const NODE_GROUP_ATTRIBUTE = '__group__'
